import { useState } from "react";
import {
    useRecordContext,
    useDelete,
    useNotify,
    useRedirect,
    useResourceContext,
} from "react-admin";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const ConfirmDeleteButton = ({path}:any) => {
    const [open, setOpen] = useState(false);
    const record = useRecordContext();
    const resource = useResourceContext();
    const notify = useNotify();
    const redirect = useRedirect();
    const [deleteOne, { isLoading }] = useDelete();

    if (!record) return null;

    const handleClick = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleConfirm = () => {
        deleteOne(
            resource,
            { id: record.id, previousData: record },
            {
                onSuccess: () => {
                    notify("Deleted successfully", { type: "info" });
                    const resourcePath = path || resource;
                    redirect(`/${resourcePath}`);
                },
                onError: (error: any) => {
                    notify(
                        error?.message || "Error while deleting",
                        { type: "warning" }
                    );
                },
            }
        );
        handleClose();
    };

    return (
        <>
            <Button
                color="error"
                startIcon={<DeleteIcon />}
                onClick={handleClick}
                disabled={isLoading}
            >
                Delete
            </Button>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete{" "}
                        <strong>{record?.name || "this item"}</strong>?
                        This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button
                        onClick={handleConfirm}
                        color="error"
                        disabled={isLoading}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ConfirmDeleteButton;
